import { BarChart3, CalendarCheck, ConciergeBell, CreditCard, LucideIcon } from 'lucide-react';

export interface MarketingSlide {
  id: string;
  icon: LucideIcon;
  /** Klucze tłumaczeń. Treść slajdu żyje w słownikach, nie w kodzie. */
  eyebrowKey: string;
  titleKey: string;
  descriptionKey: string;
  pointKeys: string[];
  /** Opis miejsca na grafikę, czytany przez czytniki ekranu do momentu wstawienia zrzutu. */
  mediaAltKey: string;
}

const base = 'auth.signIn.slides';

/*
 * Kolejność slajdów to kolejność rozmowy sprzedażowej: najpierw pieniądze (Stripe),
 * potem kalendarz rezerwacji, dalej zamówienia gości i na końcu wyniki. Numeracja
 * kropek po lewej odpowiada tej liście, więc dopisanie slajdu nie wymaga nic więcej.
 */
export const MARKETING_SLIDES: MarketingSlide[] = [
  {
    id: 'payments',
    icon: CreditCard,
    eyebrowKey: `${base}.payments.eyebrow`,
    titleKey: `${base}.payments.title`,
    descriptionKey: `${base}.payments.description`,
    pointKeys: [`${base}.payments.point1`, `${base}.payments.point2`],
    mediaAltKey: `${base}.payments.mediaAlt`,
  },
  {
    id: 'calendar',
    icon: CalendarCheck,
    eyebrowKey: `${base}.calendar.eyebrow`,
    titleKey: `${base}.calendar.title`,
    descriptionKey: `${base}.calendar.description`,
    pointKeys: [`${base}.calendar.point1`, `${base}.calendar.point2`],
    mediaAltKey: `${base}.calendar.mediaAlt`,
  },
  {
    id: 'orders',
    icon: ConciergeBell,
    eyebrowKey: `${base}.orders.eyebrow`,
    titleKey: `${base}.orders.title`,
    descriptionKey: `${base}.orders.description`,
    pointKeys: [`${base}.orders.point1`, `${base}.orders.point2`],
    mediaAltKey: `${base}.orders.mediaAlt`,
  },
  {
    id: 'insights',
    icon: BarChart3,
    eyebrowKey: `${base}.insights.eyebrow`,
    titleKey: `${base}.insights.title`,
    descriptionKey: `${base}.insights.description`,
    pointKeys: [`${base}.insights.point1`, `${base}.insights.point2`],
    mediaAltKey: `${base}.insights.mediaAlt`,
  },
];

/** Ile trwa jeden slajd. Ta sama wartość napędza pasek postępu przy kropce. */
export const SLIDE_DURATION_MS = 7000;
